import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'

Vue.use(VueSweetalert2)

const Alert = {
  install (Vue, options) {
    Vue.prototype.$alertOptions = function (options) {
      return Vue.swal(options)
    }

    Vue.prototype.$alert = function (text) {
      return Vue.swal({
        text: text,
        icon: 'info'
      })
    }

    Vue.prototype.$confirm = function (heading, text) {
      return Vue.swal({
        title: heading,
        text: text,
        // type: 'warning',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#ebebeb',
        confirmButtonText: 'Ja',
        cancelButtonText: 'Avbryt'
      })
    }

    Vue.prototype.$closeAlert = function () {
      Vue.swal.close()
    }
  }
}

export default Alert



// WEBPACK FOOTER //
// ./src/plugins/alert.js